import { TopoNode } from "../Topology/TopoNode";
import { DeviceNode } from "../Topology/DeviceNode";
import { MultiNode } from "../Topology/MultiNode";
import { DeviceGroupNode } from "./DeviceGroupNode";
//import { ImageNode } from "../Topology/ImageNode";

export class TopoUtils {

	public static ReadTopoNode(obj: any, context: any): TopoNode {

		let result: TopoNode = null;

		if (obj.device_node !== undefined) {
			result = new DeviceNode();
			result.Read(obj, context);
		}
		else if (obj.device_group_node !== undefined) {
			result = new DeviceGroupNode();
			result.Read(obj, context);
		}
		else if (obj.hub_node != undefined) {
			result = new MultiNode();
			result.Read(obj, context);
		}
		else if (obj.image_node !== undefined) {
			//result = new ImageNode();
			//result.Read(obj, context);

			console.log("ImageNode not yet implemented");
		}
		else {
			console.log("Unrecognized TopoNode type");
		}

		return result;
	}

}